import React from 'react'

const BulkUploadContext = React.createContext();

export default BulkUploadContext
